
var curWindowWidth = window.innerWidth;

window.addEventListener("resize", function (event) {
  curWindowWidth = window.innerWidth;
});

window.addEventListener("scroll", function (event) {
  var scrollPos = document.documentElement.scrollTop,
    speakerSec = document.querySelector(".speaker-details-section"),
    speakerSecRight = speakerSec.querySelector(
      ".speaker-details-section__right"
    ),
    speakerSecLeft = speakerSec.querySelector(
      ".speaker-details-section__left"
    );

  if (speakerSec && speakerSecRight && curWindowWidth >= 980) {
    var speakerSecPos = speakerSec.offsetTop,
      speakerSecHeight = speakerSec.offsetHeight,
      speakerSecLeftHeight = speakerSecLeft.offsetHeight,
      speakerSecRightHeight = speakerSecRight.offsetHeight;

    if (speakerSecLeftHeight > speakerSecRightHeight + 150 ) {
      if (
        scrollPos > speakerSecPos + 88 &&
        scrollPos < speakerSecPos + speakerSecHeight - speakerSecRightHeight - 50
      ) {
        speakerSecRight.classList.add("sticky");
        speakerSecRight.classList.remove("sticky-bottom");
      } else if (
        scrollPos > speakerSecPos + 88 &&
        scrollPos < speakerSecPos + speakerSecHeight - 42 - 50
      ) {
        speakerSecRight.classList.add("sticky-bottom");
        speakerSecRight.classList.remove("sticky");
      } else {
        speakerSecRight.classList.remove("sticky-bottom");
        speakerSecRight.classList.remove("sticky");
      }
    } else {
      speakerSecRight.classList.remove("sticky-bottom");
      speakerSecRight.classList.remove("sticky");
    }
  } else {
    speakerSecRight.classList.remove("sticky-bottom");
    speakerSecRight.classList.remove("sticky");
  }
});
